module.exports = __webpack_public_path__ + "img/icon3.65e560e.png";